import React, { createRef, useEffect } from "react";

import PageMeta from "core/PageMeta";
import IconApiSection from "./IconApiSection";
import PhotosSection from "./PhotosSection";
import IconsSection from "./IconsSection";
import Hero from "./Hero";

import { StyledPricingMarketingPage } from "./styles";

const PricingMarketingPage = () => {
    const photosRef = createRef();

    useEffect(() => {
        if (
            photosRef &&
            photosRef.current &&
            location.href.includes("#photos")
        ) {
            // Looks hacky- but React doesn't like to link to anchors in components outside of the ones currently rendered
            // (this is for the case of coming from the photo detail licensing info)
            // Plus- Chrome has wacky "scroll to where i left off (or top)" behavior that executes AFTER all components have rendered
            // A small interval makes it work on Chrome and still works in other browsers
            setTimeout(() => {
                photosRef.current.scrollIntoView();
            }, 500);
        }
    }, []);

    return (
        <>
            <PageMeta
                title="Icon & Photo Pricing and Royalty-Free Licenses | Noun Project"
                removeDescriptionTag
            >
                <meta
                    name="description"
                    content="Millions of icons and stock photos for any budget. Free icons and photos plus more options with affordable royalty-free licenses."
                />
            </PageMeta>
            <StyledPricingMarketingPage>
                <Hero />
                <IconsSection />
                <div ref={photosRef}>
                    <PhotosSection />
                </div>
                <IconApiSection />
            </StyledPricingMarketingPage>
        </>
    );
};

export default PricingMarketingPage;
